import {
  Box,
  Container,
  VStack,
  useToast,
  Text,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import Button from "components/Button/Button";
import Input from "components/Input/Input";
import { RSelect, OptionLabel } from "components/Select/RSelect";
import { useState, useRef, useEffect, useMemo } from "react";
import Recaptcha from "react-google-recaptcha";

import { usePatchPhoneNumberMutation } from "services/arbitraryApi";

import { useHistory, useLocation } from "react-router-dom";

import useCountries from "hooks/useCountries";

const VerifyPhoneNumber = () => {
  const toast = useToast();
  const history = useHistory();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  console.log("PARAMS", searchParams.get("email"));

  const recaptchaInstanceRef = useRef();

  const [patchPhone, { isLoading, isSuccess, isError, error }] =
    usePatchPhoneNumberMutation();

  const getError = (error) => {
    function isObj(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
    const value = isObj(error) ? Object.values(error)[0] : error;
    return value ?? "An unexpected error occurred";
  };

  const { data, status, detectedCountry } = useCountries();
  const [phone, setPhone] = useState({ code: {}, number: "" });
  const countryIsLoading = useMemo(() => status === "fetching", [status]);

  const phoneCodeOptions = () =>
    data &&
    data?.map((country) => ({
      label: (
        <OptionLabel
          rtl
          label={`+${country?.callingCodes[0] ?? ""}`}
          img={country.flag ?? ""}
        />
      ),
      value: `+${country?.callingCodes[0] ?? ""}`,
    }));

  const handlePhone = (input) => {
    setPhone({ ...phone, ...input });
    const countryInfo = data?.find(
      (c) => c.callingCodes[0] === input?.code?.value.split("+")[1]
    );

    // input?.code && handleFormData({ country: countryInfo?.name });

    console.log(
      "some",
      countryInfo?.name,
      `${phone?.code?.value}${input.number}`
    );

    // if (phone?.code?.value && input?.number) {
    //   console.log("some", `${phone?.code?.value}${input.number}`);
    //   debounce(
    //     () => makeCheck("phone", `${phone?.code?.value}${input.number}`),
    //     1000
    //   )();
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (navigator.onLine === true) {
      const captcha = await recaptchaInstanceRef.current?.executeAsync();
      //   const reqData = { code: pin, captcha };
      const reqData = {
        email: searchParams.get("email"),
        countryCode: phone?.code?.value,
        phone: `${phone?.code?.value}${phone?.number}`,
        humanKey: captcha,
      };
      console.log("REQUEST DATA", reqData);

      patchPhone(reqData);
    } else {
      toast({
        position: "bottom-right",
        title: "Network Error!!",
        description: "Please check your network connection",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (isSuccess && data) {
      console.log("EMAIL VERIFICATION RESULT", data);
      recaptchaInstanceRef.current?.reset();

      //   dispatch(hydrateToken(data.token))
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Email validation successful",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      history.replace("/confirmnumber");
    }

    if (isError && error) {
      console.log("EMAIL VERIFICATION ERROR", error);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, data, isError, error, toast, history]);

  const isDisabled = () => !(phone?.code?.value && phone?.number) || isLoading;

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="lg">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Box w={["100px", "initial"]} as={Logo} />
            {/* <Heading as="h3" fontSize={["24px", "32px"]}>
              Welcome
            </Heading> */}
            <Text
              textAlign="center"
              fontSize={["32px", "3xl"]}
              mt="24px !important"
            >
              Phone Number
            </Text>
            <Text
              textAlign="center"
              fontSize={["sm", "md"]}
              color="#4e4b66"
              //   mt="24px !important"
            >
              Enter your phone number for verification
            </Text>
          </VStack>

          <Box as="form" mt="50px" onSubmit={handleSubmit}>
            <VStack>
              <InputGroup w="100%">
                <InputLeftElement
                  // left="42px"
                  w={["120px", "150px"]}
                  h="54px"
                  children={
                    <RSelect
                      defaultInputValue={detectedCountry.CountryCode}
                      placeholder="select"
                      autoComplete={false}
                      isLoading={countryIsLoading}
                      value={phone?.code ?? ""}
                      onChange={(e) => handlePhone({ code: e })}
                      options={phoneCodeOptions()}
                    />
                  }
                />
                <Input
                  //   isInvalid={
                  //     !isCheckingEmail("phone") &&
                  //     formData?.email &&
                  //     isAlreadyInUse("phone")
                  //   }
                  value={phone?.number ?? ""}
                  onChange={(e) => handlePhone({ number: e.target.value })}
                  isRequired
                  max={14}
                  //   type="tel"
                  pl={["126px", "154px"]}
                  w="100%"
                  placeholder="Phone number without a leading zero"
                  name="phoneNumber"
                />
              </InputGroup>

              <Recaptcha
                ref={recaptchaInstanceRef}
                sitekey={process.env.REACT_APP_RECAPTCHA}
                size={"invisible"}
              />

              <Button
                disabled={isDisabled()}
                isLoading={isLoading}
                minW="100%"
                minH="56px"
                fontWeight="normal"
                mt="30px !important"
                type="submit"
              >
                Submit
              </Button>
            </VStack>
          </Box>
        </Box>
      </Container>
    </VStack>
  );
};

export default VerifyPhoneNumber;
